export default function setPageTitle(sectionTitle: string): void {
  document.title = `${sectionTitle} | Checkout | John Lewis & Partners`;
}
